import React from 'react';
import {
  FiChevronRight,
  FiChevronLeft,
} from 'react-icons/fi';
import { conformToMask } from 'react-text-mask';
import { Image, standards } from '../../../../components';
import logo from '../../../../../support/assets/images/logo_fundo_branco.png';

export default function Identification(props) {
  const { sharedStates, remoteStates } = props;
  const {user, space} = remoteStates;
  const {donation} = sharedStates;
  
  return (
    <div style={{
      marginBottom:-40, width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly', alignItems: 'flex-end',
    }}
    >
      <div style={{
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
      >
        <h3 style={{ alignSelf: 'center', textAlign: 'center' }}>{space.name}</h3>
        <h5 style={{ alignSelf: 'center', margin: 5 }}>Espaço</h5>
        <div style={{ maxWidth: 100 }}>
          <Image
            src={space?.imagesPaths?.length ? space.imagesPaths[space.imagesPaths.length - 1] : ''}
            alt={`Foto de ${space?.name}`}
            rounded
            circledColor={standards.colors.red.weak}
            bottomShadow
          />
        </div>
      </div>

      <FiChevronRight style={{ position: 'relative', marginBottom: 50 }} size={20} color={standards.colors.red.weak} />
      <div style={{ width: 60, marginBottom: 15 }}>
        <Image
          src={logo}
          alt="Locall"
          rounded
        />
      </div>
      <FiChevronLeft
        style={{ position: 'relative', marginBottom: 50 }}
        size={20}
        color={standards.colors.green.weak}
      />

      <div style={{
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignItems: 'center',
      }}
      >
        <h3 style={{ alignSelf: 'center', textAlign: 'center' }}>{`${user?.firstName} ${user?.lastName}`}</h3>
        <h5 style={{ alignSelf: 'center', margin: 5, color: donation ? standards.colors.orange.medium : 'black'}}>{donation ? 'Sólidário Locall' : 'Consumidor'}</h5>
        <div style={{ maxWidth: 100 }}>

          <Image
            src={user?.imagesPaths?.length ? user.imagesPaths[user.imagesPaths.length - 1] : ''}
            alt={`Foto de ${user?.firstName}`}
            rounded
            circledColor={donation ? standards.colors.orange.medium : standards.colors.green.weak}
            bottomShadow
          />
        </div>
      </div>

    </div>
  );
}
